import { useEffect, useState } from "react";

import { getStoredUserEmail, USER_EMAIL_EVENT } from "./userStorage";

export const useDefaultEmail = () => {
  const [email, setEmail] = useState<string | undefined>(() => getStoredUserEmail());

  useEffect(() => {
    const handler = () => setEmail(getStoredUserEmail());
    window.addEventListener("storage", handler);
    window.addEventListener(USER_EMAIL_EVENT, handler);
    return () => {
      window.removeEventListener("storage", handler);
      window.removeEventListener(USER_EMAIL_EVENT, handler);
    };
  }, []);

  return email;
};
